// extracted by mini-css-extract-plugin
module.exports = {"arrow":"_41d025ce","isLeft":"_bc98f676"};